import _ from 'lodash';
import moment from 'moment';
import api from '@/utils/api';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelTemplate from './ExportExcelTemplate';

// 取得資料
export async function fetchRowDatas({
    StartDate, EndDate, AccountStart, AccountEnd,
}) {
    const url = '/AccountingSummaryReport/QueryGeneralLedger';
    const queryParams = {
        QueryType: 1,
        StartDate,
        EndDate,
        AccountStart,
        AccountEnd,
        PageSize: 1000,
        PageNum: 1,
    };

    console.log('hihihi', queryParams);

    try {
        const { data } = await api({
            url,
            method: 'GET',
            params: queryParams,
        });

        // 足夠的PageSize
        if (queryParams.PageSize > data.totalNum) {
            return data.items;
        }

        const currentList = [...data.items];
        for (let i = 0; i < Math.ceil(data.totalNum / queryParams.PageSize) - 1; i += 1) {
            queryParams.PageNum += 1;
            // eslint-disable-next-line no-await-in-loop
            const resp = await api({
                url,
                method: 'GET',
                params: queryParams,
            });
            currentList.push(...resp.data.items);
        }
        return currentList;
    } catch (ex) {
        console.log(ex);
        return [];
    }
}

// 將API資料整理成 excel 的資料
export function formatDataRows(rawDatas) {
    const filteredDetails = _.filter(rawDatas, (o) => !(!o.dat && o.serialNumber));
    const rows = [];
    const rowDivider = [];
    let currentAccno;

    filteredDetails.forEach((item, i) => {
        if (!currentAccno || currentAccno !== item.accno) {
            currentAccno = item.accno;
            if (i) rowDivider.push(i);
        } else if (i === filteredDetails.length - 1) rowDivider.push(i + 1);

        rows.push([
            item.accno,
            item.accnam,
            item.dC_TYP === 1 ? '借' : '貸',
            item.dat ? moment(item.dat).format('YYYY-MM-DD') : '',
            item.serialNumber,
            item.content,
            item.dat ? item.crD_NTD : '',
            item.dat ? item.deB_NTD : '',
            item.dC_TYP === 1 ? item.crD_Balance : item.deB_Balance,
        ]);
    });

    return { rows, rowDivider };
}

// 建立 Excel 工作表
export function createExcelSheet({ StartDate, EndDate }, rawDatas, companyName) {
    const { rows, rowDivider } = formatDataRows(rawDatas);
    const sheet = _.cloneDeep(ExportExcelTemplate);

    XLSX_STYLE.utils.sheet_add_aoa(sheet, rows, { origin: 'A4' });

    const widthSettings = [12, 18, 12, 12, 12, 55, 15, 15, 15];
    // 設定全部欄寬 (由bodyHeader定義，預設 15)
    sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));
    sheet['!rows'] = [{ hpx: 70 }, { hpx: 25 }];

    for (let i = 0; i < rowDivider.length; i += 1) {
        const START_INDEX = rowDivider[i - 1] + 3;
        const END_INDEX = rowDivider[i] + 3 - 1;

        if (i === 0) {
            sheet['!merges'].push({ s: { c: 0, r: 3 }, e: { c: 0, r: rowDivider[0] + 3 - 1 } });
            sheet['!merges'].push({ s: { c: 1, r: 3 }, e: { c: 1, r: rowDivider[0] + 3 - 1 } });
        } else if (START_INDEX !== END_INDEX) {
            sheet['!merges'].push({ s: { c: 0, r: START_INDEX }, e: { c: 0, r: END_INDEX } });
            sheet['!merges'].push({ s: { c: 1, r: START_INDEX }, e: { c: 1, r: END_INDEX } });
        }
    }

    _.forEach(sheet, (value, key) => {
        if (!key.includes('!')) {
            // 'B13' => COL: 'B', ROW: '13'
            const isLetterSingle = !Number.isNaN(Number(key.substring(1)));
            const COL = isLetterSingle ? key.substring(0, 1) : key.substring(0, 2);
            const ROW = isLetterSingle ? Number(key.substring(1)) : Number(key.substring(2));

            // 每一格
            sheet[key].s = {
                alignment: {
                    horizontal: 'left',
                    vertical: 'bottom',
                },
            };

            // 公司名稱標題
            if (key === 'A1') {
                sheet[key].s.alignment.horizontal = 'center';
                sheet[key].s.alignment.vertical = 'center';
                sheet[key].s.alignment.wrapText = true;

                sheet[key].v = `${companyName}\n會計科目總分類帳`;

                sheet[key].s.font = {
                    bold: true,
                    sz: 16,
                };
            }

            // 選取區間
            if (key === 'A2') {
                sheet[key].s.alignment.horizontal = 'left';
                sheet[key].s.alignment.vertical = 'center';

                const START_DATE = moment(+StartDate);
                const END_DATE = moment(+EndDate);
                sheet[key].v = `傳票日期範圍：${START_DATE.year() - 1911}-${START_DATE.format('MM-DD')} 至 ${END_DATE.year() - 1911}-${END_DATE.format('MM-DD')}`;
            }

            // 製表日期
            if (key === 'H2') {
                sheet[key].s.alignment.horizontal = 'right';
                sheet[key].s.alignment.vertical = 'center';
                const TODAY = moment();
                sheet[key].v = `製表日期：${TODAY.year() - 1911}-${TODAY.format('MM-DD')}`;
            }

            // 借、貸方金額格式設定
            if (COL === 'G' || COL === 'H' || COL === 'I') {
                sheet[key].s.alignment.horizontal = 'right';
                sheet[key].z = '#,##0_-;-#,##0_-;0;General';
            }

            // 科目代號、科目名稱格式設定
            if (ROW >= 3 && (COL === 'A' || COL === 'B')) sheet[key].s.alignment.vertical = 'top';

            // 表頭字體設定
            if (ROW === 3) sheet[key].s.font = { bold: true };

            // 表頭 ＆ 之後得每一列資料
            if (ROW >= 3) {
                sheet[key].s.border = {
                    bottom: { style: 'thin', color: 'FFFFFFFF' },
                    top: { style: 'thin', color: 'FFFFFFFF' },
                    left: { style: 'thin', color: 'FFFFFFFF' },
                    right: { style: 'thin', color: 'FFFFFFFF' },
                };
            }

            // 分隔線設定
            if (rowDivider.includes(ROW - 3)) sheet[key].s.border.bottom = { style: 'medium', color: 'FFFFFFFF' };
        }
    });

    return sheet;
}

// 下載 Excel
export async function downloadExcel(queryParams, companyName, rawDatas = null, directDownload = true) {
    const datas = rawDatas || (await fetchRowDatas(queryParams)); // 如果沒有給資料，就重新拿一份
    const excelBook = XLSX_STYLE.utils.book_new();
    const excelSheet = createExcelSheet(queryParams, datas, companyName);
    const fileName = `${moment(+queryParams.StartDate).format('YYYY-MM-DD')}～${moment(+queryParams.EndDate).format('YYYY-MM-DD')}會計科目總分類帳.xlsx`;

    XLSX_STYLE.utils.book_append_sheet(excelBook, excelSheet, '會計科目總分類帳');

    if (directDownload) {
        return XLSX_STYLE.writeFile(excelBook, fileName);
    }
    const excelBuffer = XLSX_STYLE.write(excelBook, { type: 'array', bookType: 'xlsx' });
    return { buffer: excelBuffer, fileName };
}
